import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './../services/services';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/publishReplay';



let headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/x-www-form-urlencoded');
let options = new RequestOptions({ headers: headers });	 

export class Roomlisting {

    constructor(public slug: string, public image: string,public product_name: string,public product_description:string) { }
}

@Injectable()
export class RoomlistingService {

  
   
    public _productlist;
    public _productlatest;
    public _products:Array<any>;
    constructor(
      private http: Http,
      
      private shareService: ShareService) {
      this._productlist = null;
  
    }
    getlatestproduct(limit:string){
    
    
		let apirul=this.shareService.getApiUrl()+'/latestproduct';
    
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });	 
	    if(limit)
	    {
		    apirul=apirul+'/'+limit;	
	    }
	    
  	
	   	if (!this._productlatest) { 	     
        this._productlatest = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);               
            
            }
            
         return this._productlatest;
    }
    
    deletelisting()
    {
	    delete this._productlist;
    }
	getRoomlist(checkindate:string,checkoutdate:string,adultpersion:string,children:string) {
	    //console.log(slug);
	    
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/hotellist/'+checkindate+'/'+checkoutdate+'/'+adultpersion+'/'+children;
	   	if (!this._productlist) { 	     
        this._productlist = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
            }
            
         return this._productlist;
	}
	
	getRoom(slug:string) {
	   
	   let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/room/'+slug;
	   	//if (!this._products.slug) { 	     
        let output= this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
          //  }
            
         return output;
	    
	    
	}
	
	doBooking(params,bookingdata) {
	    //console.log(slug)
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/json');
	    ///alert(this.getToken());
	     
	   let options= new RequestOptions({ headers:headers });
	   
	   	let apirul=this.shareService.getApiUrl()+'/booking';
	   	
	   	 //params.formdatabooking=bookingdata;
	   	 
         let formData = JSON.stringify(params);
         let formdatabooking=JSON.stringify(bookingdata);
         let body = 'request='+formData+'&bookingdata='+formdatabooking;
         console.log(body);
	   	 
        let output= this.http.post(apirul,formData,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  
       
        return output;
	         
      
	}	
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/hotel/roomlisting.services.ts